import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOMeta from '../components/SEOMeta';

const faqs = [
  {
    q: 'What payment methods do you accept?',
    a: 'We accept M-Pesa plus major debit and credit cards where available. Our team can confirm the best payment option for your order.',
  },
  {
    q: 'How long does delivery take?',
    a: 'Delivery within Nairobi is typically 1-2 business days. Orders to other counties usually take 2-4 business days depending on the destination.',
  },
  {
    q: 'Do you offer free delivery?',
    a: 'Orders above KES 5,000 qualify for free delivery within the Nairobi region. Smaller orders may include a delivery fee.',
  },
  {
    q: 'Are the products genuine?',
    a: 'Yes. We source products from trusted suppliers and distributors, and eligible products include manufacturer warranty.',
  },
  {
    q: 'Can I return a product?',
    a: 'Returns are accepted within 30 days when items are unused, complete, and in original packaging. Contact us before sending any item back.',
  },
  {
    q: 'How do I track my order?',
    a: 'After checkout, our team contacts you by phone or WhatsApp to confirm delivery details and share updates.',
  },
];

function FAQPage() {
  const [openFaq, setOpenFaq] = useState(null);
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: { '@type': 'Answer', text: faq.a },
    })),
  };

  return (
    <div className="about-page">
      <SEOMeta
        title="Frequently Asked Questions"
        description="Answers to common questions about Hercles Global payments, delivery, returns, warranties and online shopping in Kenya."
        canonical="/faq"
        jsonLd={faqJsonLd}
      />
      <Header />
      <main className="about-inner">
        <section className="about-hero">
          <h1>Frequently Asked Questions</h1>
          <p>Quick answers about shopping, paying, delivery, returns, and product support at Hercles Global.</p>
        </section>

        <section className="about-section">
          {faqs.map((faq, i) => (
            <div key={faq.q} className="faq-item">
              <button className="faq-question" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <span>{faq.q}</span>
                <span className="faq-chevron">{openFaq === i ? '^' : 'v'}</span>
              </button>
              {openFaq === i && <div className="faq-answer">{faq.a}</div>}
            </div>
          ))}
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default FAQPage;
